<script setup lang="ts">
  import { IconArrowLeft, IconArrowRight, Text } from '@ui-kit';

  const { text, subText } = defineProps<{
    text?: string;
    subText?: string;
  }>();
</script>

<template>
  <div class="pointer-barcode-button">
    <div class="pointer-barcode-button__left">
      <span class="pointer-barcode-button__line" />
      <IconArrowLeft style="stroke: var(--sf-base-icon-white);" />
    </div>
    <div class="pointer-barcode-button__description">
      <Text v-if="text" color="white" v-html="text"/>
      <Text v-if="subText" color="secondary" v-html="subText"/>
    </div>
    <div class="pointer-barcode-button__right">
      <IconArrowRight style="stroke: var(--sf-base-icon-white);" />
      <span class="pointer-barcode-button__line" />
    </div>
  </div>
</template>

<style scoped>
  .pointer-barcode-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 4px;
  }

  .pointer-barcode-button__right,
  .pointer-barcode-button__left {
    display: flex;
    gap: 8px;
    align-items: center;
    animation-name: arrow;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .pointer-barcode-button__description {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: center;
    white-space: break-spaces;
  }

  .pointer-barcode-button__line {
    height: 74px;
    width: 6px;
    border-radius: 10px;
    background-color: var(--sf-base-icon-white);
  }

  @keyframes arrow {
    from { gap: 8px; }
    50% { gap: 4px; }
    to { gap: 8px; }
  }
</style>